















































































































import {
    //DetectTouchScreen,
    Update
} from './mixins/mixins'
import {
    version
} from "../package.json";
import {
    platform,
    openLinkInBrowser,
    linking,
} from './mla-shared'
import Component, {
    mixins
} from 'vue-class-component'

@Component
export default class App extends mixins(Update) {
    title = "Stocking Rate Calculator"
    drawer = null
    links = [{
            name: "Home",
            icon: "home"
        },
        {
            name: "Beef",
            icon: ""
        },
        {
            name: "Sheep",
            icon: ""
        },
        {
            name: "Help",
            icon: "help"
        }
    ]

    // isTouchScreen = false
    version = version
    platform = platform()
    offset = window.pageYOffset
    breakpoint = this.$vuetify.breakpoint

    mounted() {
        // this.isTouchScreen = this.detect();

        window.onscroll = () => {
            this.offset = window.pageYOffset;
        }
        console.log(this.breakpoint)
    }

    destroyed() {
        window.onscroll = null;
    }

    etools() {
        openLinkInBrowser('https://etools.mla.com.au/');
    }

    support() {
        linking({
            operation: 'openURL',
            openURL: 'mailto:tools@mla.com.au',
        });
    }

    survey() {
        openLinkInBrowser('https://forms.office.com/Pages/ResponsePage.aspx?id=HJuCo77s1EmI6U8o95r6EQ02C2-KKipFlLU1SKga7MNUOEhUQjBSOFlUN05EU1ZURU9RT1daWVlETi4u');
    }
};
